/**
 * Generate a UUID with fallback for environments where crypto.randomUUID is not available
 * (e.g., HTTP contexts, older browsers)
 */
export function generateUUID(): string {
  try {
    // Prefer Web Crypto API when available (HTTPS or localhost)
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
  } catch (_) {
    // Fallback below
  }
  
  // Fallback UUID v4 implementation for HTTP contexts
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

